import type { IValidatedResponse } from '../../httpClient';
import { deleteRequest } from '../../httpClient';
import type { IDeleteAccountResponse } from './delete-account-response';
import { deleteAccountResponseSchema } from './delete-account-response';

export async function deleteAccountApi(): Promise<IValidatedResponse<IDeleteAccountResponse>> {
  return deleteRequest<IDeleteAccountResponse>({
    path: '/account/me',
    schema: deleteAccountResponseSchema,
  });
}
